import React from "react";
import { Globe, Printer, Puzzle, TabletSmartphone } from "lucide-react";
import { Translate } from "components/common/Translate/Translate";
import { ISectionUseCase } from "./CropPngSectionUseCaseScaffold";
import { SectionUseCaseScaffold } from "../CropImage/CropSectionUseCaseScaffold";


const bestUseList: ISectionUseCase[] = [
    {
        title: "clarity-cropping-heading",
        subTitle: "clarity-cropping-sub-heading",
        icon: <Globe strokeWidth={1.5} width={30} height={30} />,
    },
    {
        title: "smart-cropping-heading",
        subTitle: "smart-cropping-sub-heading",
        icon: <Puzzle />,
    },
    {
        title: "social-cropping-heading",
        subTitle: "social-cropping-sub-heading",
        icon: <TabletSmartphone />,
    },
    {
        title: "custom-cropping-heading",
        subTitle: "custom-cropping-sub-heading",
        icon: <Printer />,
    },
];
const CropPngFreeContent = () => {
    return (
        <SectionUseCaseScaffold
            title={<Translate keyName="effortless-cropping-title" />}
            useCases={bestUseList}
        />
    );
};

export default CropPngFreeContent;
